var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "KModal",
    {
      attrs: {
        title: _vm.$tr("enterChannelToken"),
        submitText: _vm.coreString("continueAction"),
        cancelText: _vm.coreString("cancelAction"),
        submitDisabled: _vm.formIsDisabled || _vm.$attrs.disabled,
        cancelDisabled: _vm.formIsDisabled || _vm.$attrs.disabled,
      },
      on: {
        submit: _vm.submitForm,
        cancel: function ($event) {
          return _vm.$emit("cancel")
        },
      },
    },
    [
      _c("p", [_vm._v(_vm._s(_vm.$tr("tokenExplanation")))]),
      _vm.tokenNetworkError
        ? _c("UiAlert", { attrs: { dismissible: false, type: "error" } }, [
            _vm._v("\n    " + _vm._s(_vm.$tr("networkErrorMessage")) + "\n  "),
          ])
        : _vm._e(),
      _c("KTextbox", {
        attrs: {
          label: _vm.$tr("channelTokenLabel"),
          invalid: !_vm.tokenIsValid,
          invalidText: _vm.$tr("invalidTokenMessage"),
          autofocus: "",
          disabled: _vm.formIsDisabled || _vm.$attrs.disabled,
          autocapitalize: "none",
        },
        on: {
          blur: function ($event) {
            _vm.tokenIsBlurred = true
          },
        },
        model: {
          value: _vm.token,
          callback: function ($$v) {
            _vm.token = typeof $$v === "string" ? $$v.trim() : $$v
          },
          expression: "token",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }